import { default as app } from "app/store/state/app/middleware";

export default [...app];
